import React, { FC } from "react";

import { SimpleDialogFallback } from "../DialogComponents/DialogFallback/SimpleDialogFallback";
import { useContext } from "./hooks/useContext";

export const NewLayer: FC = () => {
  const context = useContext();

  return <SimpleDialogFallback context={{ title: context.title.text }} />;
};
